/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_Tag_CoachInputs */

const en_portal_week_tag_coach = /** @type {(inputs: Portal_Week_Tag_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

const pl_portal_week_tag_coach = /** @type {(inputs: Portal_Week_Tag_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener`)
};

/**
* | output |
* | --- |
* | "Coach" |
*
* @param {Portal_Week_Tag_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_tag_coach = /** @type {((inputs?: Portal_Week_Tag_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_Tag_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_tag_coach(inputs)
	return en_portal_week_tag_coach(inputs)
});